import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
import { WHYCHOOSEUS } from "@/src/lib/module-helper";
import Carousel from "@/src/components/common/carousel";

const WhyCHooseUs = () => {
    const isMobile = useBreakpoint("sm");

    return (
        <div className="bg-gray-100 md:py-12 py-6">
            <div className="max-w-6xl mx-auto">
                <div className="mb-8 text-center">
                    <h2 className="text-2xl text-black font-bold">
                        Why Choose <span className="text-primary">Us</span>
                    </h2>
                    {/* <p variant="p" className="text-black text-sm">
                        Quality. Reliability. Innovation. Trust.
                    </p> */}
                </div>
                {isMobile ? (
                    <Carousel
                        settings={{
                            speed: 700,
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            responsive: [
                                {
                                    breakpoint: 600,
                                    settings: {
                                        slidesToShow: 1,
                                    },
                                },
                            ],
                        }}
                    >
                        {WHYCHOOSEUS.map((item) => (
                            <div
                                key={item?.id}
                                className="p-7 flex justify-center bg-white items-center text-center w-full flex-col"
                            >
                                <div className="flex items-center justify-center w-20 h-20 bg-primaryLight rounded-full mb-5">
                                    <div className="bg-primary w-12 h-12 rounded-full flex items-center justify-center ">
                                        <Iconify
                                            icon={item?.icon}
                                            className="text-white"
                                            width={28}
                                            height={28}
                                        />
                                    </div>
                                </div>

                                <p className="text-black text-lg font-bold">
                                    {item?.title}
                                </p>
                                <p className="text-black text-sm">
                                    {item?.description}
                                </p>
                            </div>
                        ))}
                    </Carousel>
                ) : (
                    <div className="flex justify-center items-center">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 place-content-center">
                            {WHYCHOOSEUS.map((item) => (
                                <div
                                    key={item?.id}
                                    className="p-7 flex justify-center flex-col bg-white items-center text-center w-full shadow-md md:hover:shadow-lg md:hover:bg-white md:hover:scale-110 md:transition-transform md:duration-300 md:ease-in-out"
                                >
                                    <div className="flex items-center justify-center w-20 h-20 bg-primaryLight rounded-full mb-5">
                                        <div className="bg-primary w-12 h-12 rounded-full flex items-center justify-center ">
                                            <Iconify
                                                icon={item?.icon}
                                                className="text-white"
                                                width={28}
                                                height={28}
                                            />
                                        </div>
                                    </div>

                                    <p className="text-black text-lg font-bold">
                                        {item?.title}
                                    </p>
                                    <p className="text-black text-sm">
                                        {item?.description}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
export default WhyCHooseUs;
